export enum ReportType {
  ALL = 'Select Report Type',
  ACCOUNTS = 'Accounts Report',
  POSITIONS = 'Positions Report',
  TRANSACTION = 'Transaction Report',
  BENEFICIARY = 'Beneficiary Report',
}

export enum ReportTimeframe {
  LAST_YEAR = 'Last year',
  YEAR_TO_DATE = 'Year to date',
  CUSTOM_TIME_RANGE = 'Custom time range',
}
